import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

// Components
import { Divider as OxygenDivider } from '@preventx/oxygen';

export type DividerProps = SliceComponentProps<Content.DividerSlice>;

const Divider = () => <OxygenDivider />;

export default Divider;
